// Constantes y helpers del dashboard. Extraído por ENG-LOC-01.

export const CATEGORY_COLORS: Record<string, string> = {
  induction: 'bg-blue-100 text-blue-700',
  periodic: 'bg-purple-100 text-purple-700',
  document_change: 'bg-amber-100 text-amber-700',
  general: 'bg-gray-100 text-gray-700',
  reinforcement: 'bg-teal-100 text-teal-700',
  technical: 'bg-cyan-100 text-cyan-700',
  soft_skills: 'bg-pink-100 text-pink-700',
  compliance: 'bg-indigo-100 text-indigo-700',
  mandatory: 'bg-red-100 text-red-700',
};

export const CATEGORY_BORDER: Record<string, string> = {
  induction: 'border-t-blue-500',
  periodic: 'border-t-purple-500',
  document_change: 'border-t-amber-500',
  general: 'border-t-gray-400',
  reinforcement: 'border-t-teal-500',
  technical: 'border-t-cyan-500',
  soft_skills: 'border-t-pink-500',
  compliance: 'border-t-indigo-500',
  mandatory: 'border-t-red-500',
};

export const ROLE_LABELS: Record<string, string> = {
  // super_admin es el rol máximo del cliente, se muestra como "Administrador"
  // (el rol `admin` quedó deprecado — reunión 2026-06-12).
  super_admin: 'Administrador',
  admin: 'Administrador',
  supervisor: 'Supervisor',
  instructor: 'Instructor',
  employee: 'Empleado',
};

export function todayFormatted(): string {
  return new Intl.DateTimeFormat('es-CR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date());
}
